<template>
  <div class="pa-4 text-center">
    <circles-loader v-if="!error"></circles-loader>
    <div v-if="error">
      <v-card-text class="text-h5">{{ $t("message.error_generic") }}</v-card-text>
      <v-btn elevation="0" @click="navigateTo({ name: 'transactions' })" color="primary" outlined>{{ $t("message.back")
        }}</v-btn>
    </div>
  </div>
</template>

<script>
import CirclesLoader from "@/components/displays/CirclesLoader.vue";
import Api from "@/services/Api";
import {Environment} from "@/services/Environment";

export default {
  data() {
    return {
      transactionId: this.$route.params.transactionId,
      memberId: this.$route.params.memberId,
      sessionId: null,
      stripeAccountId: null,
      saveCreditCard: this.$route.query.saveCard,
      paymentOptions: this.$route.query.paymentOptions,
      stripePublishableKey: null,
      error: false,
    };
  },
  components: {
    CirclesLoader,
  },
  created() {
    //Get transaction, if not cancelled, proceed
    if (this.transactionId || this.memberId) {
      Api()
        .get(
          "admins/academy/" +
          this.$store.state.managedAcademy +
          "/is_connected/stripe"
        )
        .then((response) => {
          const stripeReady = response.data.stripeConnected;
          if (stripeReady) {
            this.stripeAccountId = response.data.id;
            this.initCreditCardUpdateCheckout();
          } else {
            this.showAlert("error", "Oops!", this.$t("message.error_generic"));
          }
        });
    }
  },
  watch: {},
  methods: {
    initCreditCardUpdateCheckout() {
      let postData = {};
      if (this.$route.query.source)
        postData.source = this.$route.query.source;
      if (this.saveCreditCard) postData.saveCreditCard = true;
      if (this.paymentOptions)
        postData.paymentTypes = this.paymentOptions;
      let url =
        "admins/academy/" +
        this.$store.state.managedAcademy +
        "/payments/cc/update/" +
        this.transactionId;
      if (this.memberId)
        url =
          "admins/academy/" +
          this.$store.state.managedAcademy +
          "/payments/cc/update/member/" +
          this.memberId;
      Api()
        .patch(url,
          postData
        )
        .then((response) => {
          const data = response.data;
          if (data) {
            this.sessionId = data.id;
            this.checkout();
          }
        })
        .catch((e) => {
          this.error = true;
          if (e) {
            if (e.response.data && e.response.data.message)
              this.showAlert("error", e.response.data.message);
            else
              this.showAlert("error", "Oops!", this.$t("message.error_generic"));
          }
        });
    },
    checkout() {
      this.stripePublishableKey = Environment.get("VUE_APP_STRIPE_PUBLISHABLE_KEY");
      if (this.stripeAccountId && this.stripePublishableKey) {
        /*eslint-disable no-undef*/
        try {
          var stripe = Stripe(this.stripePublishableKey, {
            stripeAccount: this.stripeAccountId,
          });
          /*eslint-disable no-undef*/
          stripe.redirectToCheckout({
            sessionId: this.sessionId,
          });
        } catch (e) {
          this.error = true;
          console.log(e);
        }
      } else {
        console.log("No stripe accountId!");
        this.showAlert("error", "Oops!", this.$t("message.error_generic"));
      }
    },
  },
};
</script>

<style scoped></style>
